import { neutral60opacity05 } from './../../../colors/neutral';
import { blue20opacity15 } from '../../../colors/blue';
import { gray80 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiAccordion = {
    defaultProps: { square: true },
    styleOverrides: {
        root: {
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            boxShadow: 'none',
            '& [class*=MuiAccordionSummary-root]': {
                flexDirection: 'row-reverse',
                minHeight: rem(34),
                '&[class*=Mui-focusVisible]': { backgroundColor: blue20opacity15 },
                '& [class*=MuiAccordionSummary-expandIcon]': {
                    marginInlineEnd: rem(8),
                },
                '&[class*=Mui-expanded]': {
                    minHeight: rem(34),
                    fontWeight: 500,
                    '& [class*=MuiTypography-root]': {
                        fontWeight: 500,
                    },
                    '& [class*=MuiAccordionSummary-expandIcon]': {
                        color: gray80,
                    },
                },
            },
            '& [class*=MuiAccordionSummary-content]': {
                margin: 0,
                paddingBlock: 0,
                paddingInline: rem(8),
            },
        },
    },
    customOverrides: {
        small: {
            '& [class*=MuiAccordionSummary-root]': {
                flexDirection: 'row-reverse',
                minHeight: rem(30),
                paddingBlock: 0,
                paddingInline: rem(12),
                '&[class*=Mui-expanded]': { minHeight: rem(30) },
            },
            '& [class*=MuiAccordionSummary-content]': {
                margin: 0,
                fontSize: '0.775rem',
                '&[class*=Mui-expanded]': { margin: 0 },
            },
            '& [class*=MuiAccordionSummary-expandIcon]': {
                height: rem(12),
                marginInlineEnd: rem(8),
                padding: 0,
                width: rem(12),
            },
        },
        noContentPadding: {
            '& [class*=MuiAccordionDetails-root]': {
                padding: 0,
            },
        },
        filled: {
            '& [class*=MuiAccordionSummary-root]': {
                backgroundColor: neutral60opacity05,
            },
        },
    },
};
